<template>
    <div>
        <!-- loading spinner -->
        <div v-if="!deviceDataLoaded" id="live-data-loading" style="text-align: center;">
            <div class="lds-facebook"><div></div><div></div><div></div></div>
            <div>Connecting to live data feed...</div>
        </div>

        <!-- content -->
        <div v-else>
            <!-- controls -->
            <div style="width: 100%; float:left;">
                <!-- live data -->
                <div style="position: relative; padding-left:20px; padding-top: 5px; float: left;">
                    <span style="color:red; font-weight: bold;">LIVE DATA</span>
                    <svg height="50" width="50" class="blinking" style="position:absolute; top:-4px; left:-11px;">
                        <circle cx="20" cy="20" r="5" fill="red" />
                    </svg> 
                </div>

                <!-- export to exccel button -->
                <button type="button" style="float: right; margin-bottom: 25px; margin-left: 15px;" class="btn btn-primary btn-sm" disabled>
                    <i class="fa-solid fa-file-arrow-down"></i>
                    <span style="padding-left: 10px">Export Excel</span>
                </button>

                <!-- data select dwondown -->
                <b-form-select style="float: right; width: 150px;" v-model="dataSelection" :options="dataSelectionOptions" size="sm"></b-form-select>                

                <!-- search box -->
                <b-input-group style="float: right; width: 200px; margin-right: 15px;">
                    <b-input-group-prepend>
                        <span class="input-group-text"><i class="fa-solid fa-magnifying-glass"></i></span>
                    </b-input-group-prepend>
                    <b-form-input class="LoginInput" size="sm" placeholder="Search"></b-form-input>
                </b-input-group>                

                <!-- Smmmary Info -->
                <div style="width: 100%; float: left; padding-bottom: 16px;">
                    <div style="float: left">
                        <div v-if="newBatch" id="today-count" class="animate__animated animate__rubberBand" style="position: absolute; z-index: 999; font-size: 39px; color: #28a745;"><b>{{ (dataSelection == 'aquaculture'  ? dataItemsAquacultureToday : dataItemsToday )}}</b></div>
                        <div v-else id="today-count" style="position: absolute; font-size: 39px;"><b>{{ dataItemsToday }}</b></div>
                        <div v-if="newBatch" style="margin-top: -7px; color: #28a745; height: 55px;">BATCHES TODAY</div>
                        <div v-else style="margin-top: -7px; color: grey">BATCHES TODAY</div>
                    </div>
                    <div style="float: left; padding-left: 45px">
                        <div style="position: absolute; font-size: 39px; color: #6c757d; font-weight: 200;">{{ dataItems.length }}</div>
                        <div style="margin-top: -7px; color: grey; height: 55px;">BATCHES TOTAL</div>
                    </div>

                    <!-- <button type="button" @click="batchCountUpdate()" class="btn btn-primary btn-sm action-button">
                        Test
                    </button> -->
                </div>

            </div>

            <!-- Grid advanced-->
            <div :class="dataSelection == 'advanced' ? 'show-grid' : 'hide-grid'" id="deviceBatchData_grid_advanced" style="width: 100%; float:left;">
                <Grid
                    :style="{ 
                        'font-size': '13px',
                        'height': 'calc(100vh - 409px)'
                    }"
                    :data-items="dataItems"
                    :sortable="true"
                    :sort="sort"
                    :pageable="false"
                    :skip="skip"
                    :take="take"
                    :total="total"
                    :columns="columnsAdvanced"
                    @pagechange="pageChangeHandler"
                    @sortchange="sortChangeHandler"
                    :loader="loader"
                    >
                </Grid>
            </div>

            <!-- item count -->
            <div>
                <div id="item-count">
                    Items: {{ dataItems.length }}
                </div>
            </div>

        </div>

    </div>    
</template>

<script>
import { Grid } from '@progress/kendo-vue-grid';
import moment from 'moment';

import batchData_Virtual from './device_batch_data_virtual.json';

export default {
    name: 'DeviceDataBatches_Virtual',
    components: {
        Grid: Grid,
    },
    data: function () {
        return {
            selectedBatchID: null,
            deviceBatchData: [],
            deviceDataLoaded: false,
            loader: false,
            dataItems: [],
            dataItemsToday: 0,
            skip: 0,
            take: 10,
            sort: [{ field: 'BatchID', dir: 'asc' }],
            columnsAdvanced: [
                //   { field: 'Playback', title: 'Playback', width: 70 },
                { field: 'BatchID', title: 'Batch ID', width: 100, locked: true },
                { field: 'SampleType', title: 'Sample Type', width: 200, locked: true },
                { field: 'RunStartTime', title: 'Run Start Time', width: 200, locked: true },
                { field: 'Operator', title: 'Operator', width: 200 },
                // { field: 'Temperature', title: 'Temperature (°C)', width: 200 },
                // { field: 'FlowRate', title: 'Flow Rate (L/min)', width: 200 },
                // { field: 'Duration', title: 'Duration (seconds)', width: 200 },
                { field: 'Status', title: 'Status', width: 200 },
                { field: 'AbortComment', title: 'Abort Comment', width: 200 },
            ],
            search: null,
            dataSelectionOptions: [{ value: 'advanced', text: 'Advanced' },],
            dataSelection: 'advanced',
            newBatch: false,
            previousCountAquaculture: null,
            previousCount: null,
            initialLoad: true,
            initialLoadAquaculture: true,
        };
    },
    props: ['item', 'autoUpdateDeviceData'],
    computed: {
        result: {
            get: function () {
                return this.dataItems.slice(this.skip, this.take + this.skip);
            },
        },
        total() {
            return this.dataItems ? this.dataItems.length : 0;
        },
    },
    mounted() {
        this.getBatchData();

        // dynamically set height of google maps component
        document.getElementById("map-container").style.height = "calc(100vh - 419px)";
    },
    methods: {
        async getBatchData() {
            this.newBatch = false;
            this.previousCount = this.dataItems.length;
            
            var options = { hour12: false };

            this.dataItemsToday = 0;

            for(let i = 0; i < batchData_Virtual.length; i++) {
                try 
                {
                    // convert string to date
                    batchData_Virtual[i].Started = new Date(batchData_Virtual[i].Started).toString();
                }
                catch (e){
                    console.log("Date error...")
                    batchData_Virtual[i].Started = new Date().setHours(new Date().getHours() - 1).toString();
                    batchData_Virtual[i].Finished = (new Date(batchData_Virtual[i].Started).setHours(new Date().getHours() - 1) + 90000).toString();
                }

                // add id for table
                batchData_Virtual[i].id = i + 1;

                // format dates
                if(batchData_Virtual[i].Started  != null) {
                    batchData_Virtual[i]['Processed'] = moment(batchData_Virtual[i].Started).fromNow();
                    batchData_Virtual[i].Started = new Date(batchData_Virtual[i].Started).toLocaleString('en-AU', options);
                }
                if(batchData_Virtual[i].Finished  != null) {
                    batchData_Virtual[i].Finished = new Date(batchData_Virtual[i].Finished).toLocaleString('en-AU', options);
                }

                // adjusting field names
                batchData_Virtual[i]['Temp Setpoint'] = batchData_Virtual[i]['Temp. Setpoint'];
                batchData_Virtual[i]['Temp Tolerance'] = batchData_Virtual[i]['Temp. Tolerance'];
                batchData_Virtual[i]['Start Temp'] = batchData_Virtual[i]['Start Temp.'];
                batchData_Virtual[i]['End Temp'] = batchData_Virtual[i]['End Temp.'];
                batchData_Virtual[i]['Min Temp'] = batchData_Virtual[i]['Min Temp.'];
                batchData_Virtual[i]['Max Temp'] = batchData_Virtual[i]['Max Temp.'];

                // calc daily bathces count
                var batchStartDate = batchData_Virtual[i].Started.substring(0,10);
                var todaysDate = moment().format('DD/MM/YYYY');
                if(batchStartDate == todaysDate) {
                    this.dataItemsToday++;
                }
            }

            this.deviceBatchData = batchData_Virtual;
            this.deviceDataLoaded = true;

            // for kendo grid
            this.dataItems = this.deviceBatchData;

            // highlight new batch count if it's increased
            if(!this.initialLoad && this.dataItems.length > this.previousCount) {
                this.newBatch = true;
            }

            this.initialLoad = false;
        },
        
        pageChangeHandler: function (event) {
            this.loader = true;
            // The idea behind using the following setTimeout method is to
            // demonstrate how we can show a loader while fetching data.
            // In a real-life scenarios with remote data binding, the 'loader'
            // property should be updated before making a server request
            // and after the request completes.
            setTimeout(() => {
                this.loader = false;
                this.skip = event.page.skip;
                this.take = event.page.take;
            }, 300);
        },
        sortChangeHandler: function (e) {
            this.loader = true;
            // The idea behind using the following setTimeout method is to
            // demonstrate how we can show a loader while fetching data.
            // In a real-life scenarios with remote data binding, the 'loader'
            // property should be updated before making a server request
            // and after the request completes.
            setTimeout(() => {
                this.loader = false;
                this.sort = e.sort;
            }, 200);
        },
        dataSelectionChange() {
            console.log("dataSelectionChange clicked!");                
        },
        batchCountUpdate() {
            console.log("batchCountUpdate() clicked");

            this.newBatch = true;
        }
    }
}
</script>

<style>
#item-count {
    float: right;
    font-size: 13px;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";        
}

.show-grid {
    display: block;
}

.hide-grid {
    display: none;
}
</style>
